import React from 'react'

import useStyles from './searchlight-confirmation-modal.style'

import { useDispatch, useSelector } from 'react-redux'
import { selectIsLoading, selectApiKey, selectHash } from '@selectors'

import { SEARCHLIGHT_CONFIRM_MODAL_CLOSE, SEARCHLIGHT_SUBMIT, ON_SUBMIT_SEARCHLIGHT } from '@redux/actions/types'

import { BUTTON_CANCEL, LAUNCH, LAUNCH_SCENARIO } from '../../assets/i18n/strings'
import i18n from 'i18n-js'

import { Button, IconInline, Paragraph, Title, WHITE } from '@omnilert/components'

import Modal from '@components/modal/modal.component'

const SearchlightConfirmationModal = (props) => {
  const classes = useStyles(props)

  const dispatch = useDispatch()

  const isVisible = useSelector(state => state.searchlight.showSearchlightConfirmationModal)
  const loading = useSelector(selectIsLoading)
  const isSubmittingAction = loading.some(item => item.loadingType === SEARCHLIGHT_SUBMIT)

  const action = useSelector(state => state.searchlight.action)

  const confirmationText = `Are you sure you want to launch "${action?.title}"?`

  const apiKey = useSelector(selectApiKey)
  const hash = useSelector(selectHash)
  const subscriberId = useSelector(state => state.auth.subscriberId)
  const auth = { apiKey, hash, subscriberId }

  const handleOnClickCancel = () => {
    dispatch({ type: SEARCHLIGHT_CONFIRM_MODAL_CLOSE })
  }

  const handleOnClickConfirm = () => {
    const { scenarioId, documentId } = action

    const data = {
      category: '',
      message: '',
      anonymous: false,
      scenario_id: scenarioId,
      subscriber_id: auth.subscriberId,
      fb_id: documentId,
      type: ''
    }

    dispatch({ type: ON_SUBMIT_SEARCHLIGHT, payload: { auth, data } })
  }

  return (
    <Modal isVisible={isVisible}>
      <div>
        <div className={classes.iconContainer}>
          <IconInline
            className={classes.icon}
            name='check'
            rotate={0}
            size={162}
          />
        </div>
        <div className={classes.modalTextContainer}>
          <Title
            color={WHITE}
            size='md'
          >
            {i18n.t(LAUNCH_SCENARIO)}
          </Title>
          <Paragraph
            color={WHITE}
            size='lg'
          >
            {confirmationText}
          </Paragraph>
        </div>

        <Button
          className={classes.button}
          fullWidth
          isLoading={isSubmittingAction}
          onClick={handleOnClickConfirm}
          title={i18n.t(LAUNCH)}
          variant='solid'
        />
        <Button
          className={classes.button}
          fullWidth
          onClick={handleOnClickCancel}
          title={i18n.t(BUTTON_CANCEL)}
        />
      </div>
    </Modal>
  )
}

export default SearchlightConfirmationModal
